export default "__VITE_ASSET__CqtdoRQL__"